import notifee from '@notifee/react-native';
import _ from 'lodash';
import { CATEGORIES, CHANNELS } from './ChannelsAndCategories';
import { notificationEventListener } from './helpers';

void notifee.createChannels(_.values(CHANNELS));
void notifee.setNotificationCategories(CATEGORIES);
notifee.onBackgroundEvent(notificationEventListener);
notifee.onForegroundEvent(notificationEventListener);
